import { Directive, HostBinding, Input } from '@angular/core';
import { IconPosition } from '@nibtravel/shared/ui/components/link-icon';

import {
  BtnShape,
  BtnShapeInput,
  BtnShapeMap,
  BtnSize,
  BtnSizeInput,
  BtnSizeMap,
  BtnType,
  BtnTypeInput,
  BtnTypeMap,
} from './button.model';

const defaultCss = ['btn'];

@Directive()
export abstract class ButtonBaseComponent {
  #btnType = 'btn--default';
  #btnSize = 'btn--md';
  #btnShape = 'btn--round';

  @Input()
  @HostBinding('id')
  id!: string;
  /** The id of e2e tag */
  @Input() e2eId: string | null = null;
  @Input() icon!: string;
  @Input() iconSize!: string;
  @Input() iconPosition = IconPosition.Start;
  @Input() text!: string;
  @Input() name?: string;
  @Input() target?: string;
  @Input()
  set type(value: BtnTypeInput) {
    this.#btnType = BtnTypeMap[value] || BtnTypeMap[BtnType.DEFAULT];
  }
  @Input()
  set size(value: BtnSizeInput) {
    this.#btnSize = BtnSizeMap[value] || BtnSizeMap[BtnSize.MD];
  }

  @Input()
  set shape(value: BtnShapeInput) {
    this.#btnShape = BtnShapeMap[value] || BtnShapeMap[BtnShape.ROUND];
  }

  get btnCss(): string[] {
    return [...defaultCss, this.#btnType, this.#btnSize, this.#btnShape];
  }
}
